module.exports = __webpack_public_path__ + "img/ingeray.b3ce820a.svg";